import React from 'react';
import { Star, Quote } from 'lucide-react';
export const Testimonials = () => {
  const testimonials = [{
    id: 1,
    name: 'Michael Thompson',
    position: 'CEO, TechStart',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/eeSWkJ3ccUxeHDGRQefHjv/457shots_so.png',
    quote: "OTO completely transformed our product's user experience. Their designs are not only beautiful but incredibly functional. Our user engagement increased by 45% after implementing their redesign."
  }, {
    id: 2,
    name: 'Emily Rodriguez',
    position: 'Product Manager, HealthTech',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/sxmxGwD5gf1F5CTGR42hgb/26_100.png',
    quote: "Working with OTO was a pleasure from start to finish. They took the time to understand our users' needs and created intuitive interfaces that perfectly aligned with our business goals."
  }, {
    id: 3,
    name: 'David Kim',
    position: 'Founder, E-commerce Platform',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/gnWbTCdueQNDNp57FvRd5R/667_3x_shots_so.png',
    quote: "OTO's design work helped us stand out in a crowded marketplace. Their attention to detail and understanding of user psychology resulted in a 60% increase in conversion rates on our platform."
  }];
  return <section className="py-20 bg-indigo-50" data-id="element-183">
      <div className="container mx-auto px-4 md:px-6" data-id="element-184">
        <div className="text-center mb-16" data-id="element-185">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-186">
            Client Testimonials
          </h2>
          <div className="w-20 h-1 bg-indigo-600 mx-auto mb-6" data-id="element-187"></div>
          <p className="text-gray-600 max-w-2xl mx-auto" data-id="element-188">
            Don't just take my word for it. Here's what my clients have to say
            about working with me.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-189">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-white p-8 rounded-lg shadow-md relative" data-id="element-190">
              <div className="absolute -top-4 -right-4" data-id="element-191">
                <Quote size={40} className="text-indigo-200" data-id="element-192" />
              </div>
              <div className="flex items-center mb-6" data-id="element-193">
                {[...Array(5)].map((_, i) => <Star key={i} size={16} className="text-yellow-400 fill-current" data-id="element-194" />)}
              </div>
              <p className="text-gray-600 mb-6 italic" data-id="element-195">"{testimonial.quote}"</p>
              <div className="flex items-center" data-id="element-196">
                <div className="w-12 h-12 rounded-full overflow-hidden mr-4 bg-indigo-100 flex items-center justify-center" data-id="element-197">
                  <img src={testimonial.image} alt="Dredget app design" className="w-full h-full object-cover" data-id="element-198" />
                </div>
                <div data-id="element-199">
                  <h4 className="font-bold" data-id="element-200">{testimonial.name}</h4>
                  <p className="text-sm text-gray-500" data-id="element-201">
                    {testimonial.position}
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};